/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Prices_Label_Single_30Inputs */

const en_prices_label_single_30 = /** @type {(inputs: Prices_Label_Single_30Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A single 30 minute lesson`)
};

const es_prices_label_single_30 = /** @type {(inputs: Prices_Label_Single_30Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una clase de 30 minutos`)
};

const de_prices_label_single_30 = /** @type {(inputs: Prices_Label_Single_30Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einzelne Golfstunde à 30 Minuten`)
};

const zh_prices_label_single_30 = /** @type {(inputs: Prices_Label_Single_30Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`单次 30 分钟课程`)
};

const ar_prices_label_single_30 = /** @type {(inputs: Prices_Label_Single_30Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`درس واحد لمدة 30 دقيقة`)
};

const fr_prices_label_single_30 = /** @type {(inputs: Prices_Label_Single_30Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une leçon de 30 minutes`)
};

const vi_prices_label_single_30 = /** @type {(inputs: Prices_Label_Single_30Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Một buổi học 30 phút`)
};

const sw_prices_label_single_30 = /** @type {(inputs: Prices_Label_Single_30Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Somo moja la dakika 30`)
};

const th_prices_label_single_30 = /** @type {(inputs: Prices_Label_Single_30Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`บทเรียนเดี่ยว 30 นาที`)
};

const bs_prices_label_single_30 = /** @type {(inputs: Prices_Label_Single_30Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jedan čas od 30 minuta`)
};

const ja_prices_label_single_30 = /** @type {(inputs: Prices_Label_Single_30Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`30分レッスン（単発）`)
};

const ko_prices_label_single_30 = /** @type {(inputs: Prices_Label_Single_30Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`30분 레슨 (단일)`)
};

const pt_prices_label_single_30 = /** @type {(inputs: Prices_Label_Single_30Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma aula de 30 minutos`)
};

const it_prices_label_single_30 = /** @type {(inputs: Prices_Label_Single_30Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una lezione singola da 30 minuti`)
};

const sv_prices_label_single_30 = /** @type {(inputs: Prices_Label_Single_30Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En lektion på 30 minuter`)
};

const nl_prices_label_single_30 = /** @type {(inputs: Prices_Label_Single_30Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een enkele les van 30 minuten`)
};

const da_prices_label_single_30 = /** @type {(inputs: Prices_Label_Single_30Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Én lektion på 30 minutter`)
};

const nb_prices_label_single_30 = /** @type {(inputs: Prices_Label_Single_30Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Én leksjon på 30 minutter`)
};

const fi_prices_label_single_30 = /** @type {(inputs: Prices_Label_Single_30Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yksi 30 minuutin oppitunti`)
};

const pl_prices_label_single_30 = /** @type {(inputs: Prices_Label_Single_30Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pojedyncza lekcja 30-minutowa`)
};

const ru_prices_label_single_30 = /** @type {(inputs: Prices_Label_Single_30Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Один урок на 30 минут`)
};

const tr_prices_label_single_30 = /** @type {(inputs: Prices_Label_Single_30Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tek 30 dakikalık ders`)
};

const hi_prices_label_single_30 = /** @type {(inputs: Prices_Label_Single_30Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`30 मिनट का एकल पाठ`)
};

const id_prices_label_single_30 = /** @type {(inputs: Prices_Label_Single_30Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Satu pelajaran 30 menit`)
};

const ms_prices_label_single_30 = /** @type {(inputs: Prices_Label_Single_30Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Satu pelajaran 30 minit`)
};

const cs_prices_label_single_30 = /** @type {(inputs: Prices_Label_Single_30Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jedna 30minutová lekce`)
};

const el_prices_label_single_30 = /** @type {(inputs: Prices_Label_Single_30Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ένα μάθημα 30 λεπτών`)
};

const he_prices_label_single_30 = /** @type {(inputs: Prices_Label_Single_30Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`שיעור בודד של 30 דקות`)
};

const af_prices_label_single_30 = /** @type {(inputs: Prices_Label_Single_30Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`'n Enkele les van 30 minute`)
};

const hu_prices_label_single_30 = /** @type {(inputs: Prices_Label_Single_30Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Egy 30 perces óra`)
};

/**
* | output |
* | --- |
* | "A single 30 minute lesson" |
*
* @param {Prices_Label_Single_30Inputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const prices_label_single_30 = /** @type {((inputs?: Prices_Label_Single_30Inputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Prices_Label_Single_30Inputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_prices_label_single_30(inputs)
	if (locale === "de") return de_prices_label_single_30(inputs)
	if (locale === "zh") return zh_prices_label_single_30(inputs)
	if (locale === "ar") return ar_prices_label_single_30(inputs)
	if (locale === "fr") return fr_prices_label_single_30(inputs)
	if (locale === "vi") return vi_prices_label_single_30(inputs)
	if (locale === "sw") return sw_prices_label_single_30(inputs)
	if (locale === "th") return th_prices_label_single_30(inputs)
	if (locale === "bs") return bs_prices_label_single_30(inputs)
	if (locale === "ja") return ja_prices_label_single_30(inputs)
	if (locale === "ko") return ko_prices_label_single_30(inputs)
	if (locale === "pt") return pt_prices_label_single_30(inputs)
	if (locale === "it") return it_prices_label_single_30(inputs)
	if (locale === "sv") return sv_prices_label_single_30(inputs)
	if (locale === "nl") return nl_prices_label_single_30(inputs)
	if (locale === "da") return da_prices_label_single_30(inputs)
	if (locale === "nb") return nb_prices_label_single_30(inputs)
	if (locale === "fi") return fi_prices_label_single_30(inputs)
	if (locale === "pl") return pl_prices_label_single_30(inputs)
	if (locale === "ru") return ru_prices_label_single_30(inputs)
	if (locale === "tr") return tr_prices_label_single_30(inputs)
	if (locale === "hi") return hi_prices_label_single_30(inputs)
	if (locale === "id") return id_prices_label_single_30(inputs)
	if (locale === "ms") return ms_prices_label_single_30(inputs)
	if (locale === "cs") return cs_prices_label_single_30(inputs)
	if (locale === "el") return el_prices_label_single_30(inputs)
	if (locale === "he") return he_prices_label_single_30(inputs)
	if (locale === "af") return af_prices_label_single_30(inputs)
	if (locale === "hu") return hu_prices_label_single_30(inputs)
	return en_prices_label_single_30(inputs)
});